import React, { useEffect, useState } from 'react';
import Button from '../../shared/components/ui/Button';
import FormInput from '../../shared/components/ui/FormInput';
import clocksvg from '../../shared/assets/svg/clocks.svg';
import Modal from '../../shared/components/ui/Modal';
import { useNavigate } from 'react-router-dom';
import {
  downloadAllotment,
  uploadAgreementLetter,
  uploadAllotmentLetter,
  downloadInvoice,
  downloadInvoiceForPaymentStages,
  approveActivity,
  getCloseDealsById,
  getTemplate,
  downloadDocument,
  uploadDocument,
  downloadSignedDocument,
  getDocumentByDealId,
  getCloseDealLoanDetails,
  approveCloseDealLoanDetails
} from '../services/api/implementation/impl';
import { useMutation, useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';

// 1) IMPORT YOUR MODAL HERE
import { ApplicantModal } from '../components/forms/ApplicantModal';
import { use } from 'react';
import { set } from 'react-hook-form';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const DealCard = ({ special, data, dealId, onSuccess, allData }) => {
  const userId = Cookies.get('userId');
  const navigate = useNavigate();
  const [showApplicantModal, setShowApplicantModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [userVertical, setUserVertical] = useState(Cookies.get('userVertical'));
  const InitialPrice =
    Number(allData?.unit?.extra_charges) +
    Number(allData?.unit?.gst) +
    Number(allData?.unit?.plc_price) +
    Number(allData?.unit?.cost);

  const { data: closeDealsById } = useQuery({
    queryKey: ['closeDealsById', dealId],
    queryFn: () => getCloseDealsById(dealId),
    enabled: !!dealId
  });
  //writw getdocumentbydealid
  const { data: getDocumentByDealIdData } = useQuery({
    queryKey: ['getDocumentByDealId', dealId],
    queryFn: () => getDocumentByDealId(dealId),
    enabled: !!dealId
  });

  // Query for loan details to check if loan exists and needs approval
  const { data: loanDetailsData, refetch: refetchLoanDetails } = useQuery({
    queryKey: ['loanDetails', dealId],
    queryFn: () => getCloseDealLoanDetails(dealId),
    enabled: !!dealId && data?.name?.toLowerCase() === 'loan approval'
  });
  console.log({ getDocumentByDealIdData });

  // Track page view
  useEffect(() => {
    mixpanel.track('Deal Card Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (getDocumentByDealIdData?.length > 0 && data?.name) {
      const documentName = data.name.toLowerCase();
      let targetName = '';

      // Determine the target document name based on the provided data.name
      if (documentName === 'allotment letter') {
        targetName = 'allotment letter';
      } else if (documentName === 'aggrement letter' || documentName === 'agreement letter') {
        targetName = 'agreement letter';
      }

      // If targetName is set, filter the template data.
      if (targetName) {
        const filteredTemplateData = getDocumentByDealIdData.filter(
          (item) => item.document_name?.toLowerCase() === targetName
        );

        console.log({ filteredTemplateData });
        if (filteredTemplateData.length > 0) {
          setSelectedDocumentId(filteredTemplateData[0].id);
        }
      }
    }
  }, [getDocumentByDealIdData]);

  console.log('data', allData);
  console.log({ closeDealsById });
  console.log({ getDocumentByDealIdData });
  console.log({ selectedDocumentId });

  let statusUpdate = '';
  let bgColor = '';
  switch (data?.status) {
    case 'Pending':
      statusUpdate = 'Application Form Pending';
      bgColor = '#e47c40';
      break;
    case 'Completed':
      statusUpdate = 'Application Form Submitted';
      bgColor = '#8aa9ac';
      break;
    case 'due':
      statusUpdate = 'Due';
      bgColor = '#e47c40';
      break;
    case 'sign_pending':
      statusUpdate = 'Sign Pending';
      bgColor = '#e47c40';
      break;
    default:
      break;
  }

  function changeDateToCustomFormat(originalDate) {
    const newDate = new Date(originalDate);
    const options = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
    return newDate.toLocaleString('en-US', options);
  }

  // ------------------- EXAMPLE MUTATIONS (unchanged) -------------------
  const { mutate: handleDownloadSigned } = useMutation({
    mutationFn: async (id) => {
      return await downloadSignedDocument(id);
    },
    onSuccess: (data, variables) => {
      const id = variables;
      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `signedCopy_${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      onSuccess();
      toast.success('Allotment Letter Downloaded');
    },
    onError: (err) => {
      toast.error(
        err?.response?.data?.message || err?.message || 'Error in downloading allotment letter'
      );
      console.error(
        err?.response?.data?.message || err?.message || 'Error in downloading allotment letter'
      );
    }
  });

  const handleUploadAllotmentLetter = async (id, payload) => {
    try {
      await uploadDocument(id, payload);
      onSuccess();
    } catch (error) {
      console.error('Error uploading allotment letter:', error);
      toast.error(
        error?.response?.data?.message || error?.message || 'Error uploading allotment letter'
      );
    }
  };

  const handleUploadAgreementForm = async (id, payload) => {
    console.log({ id, payload });
    console.log({ selectedDocumentId });
    try {
      await uploadDocument(id, payload);
      onSuccess();
    } catch (error) {
      console.error('Error uploading agreement letter:', error);
      toast.error(
        error?.response?.data?.message || error?.message || 'Error uploading agreement letter'
      );
    }
  };

  const { mutate: downloadDochandler } = useMutation({
    mutationFn: async (id) => {
      return await downloadDocument(id);
    },
    onSuccess: (data, variables) => {
      const id = variables;
      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url; // <-- Set the href attribute to the created URL
      a.download = `document_${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success('Document Downloaded');
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || err?.message || 'Error in downloading document');
      console.error(
        err?.response?.data?.message || err?.message || 'Error in downloading document'
      );
    }
  });

  const handleClickOnAllotmentLetter = (id) => {
    downloadDochandler(id);
    // navigate(`/builder/Allotment/${id}`);
  };

  const handleClikcOnAgreementLetter = (id) => {
    downloadDochandler(id);
    // navigate(`/builder/Agreement/${id}`);
  };

  const { mutate: handleInvoiceStagesDownload } = useMutation({
    mutationFn: async (id) => {
      return await downloadInvoice(id);
    },
    onSuccess: (data, variables) => {
      const id = variables;
      if (!data || data.size === 0) {
        toast.error('Error: File data is empty or invalid.');
        return;
      }
      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `performa_invoice_${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      onSuccess();
      toast.success('Invoice Downloaded');
    },
    onError: (err) => {
      let message;

      if (err?.response?.data && err?.response?.data instanceof ArrayBuffer) {
        try {
          const decoder = new TextDecoder('utf-8');
          const decoded = decoder.decode(err.response.data);
          if (decoded.includes('Customer details missing, please fill application form')) {
            message = 'Customer details missing, please fill application form';
          } else {
            message = decoded;
          }
        } catch (decodeErr) {
          console.error('Error decoding arraybuffer:', decodeErr);
          message = err?.message || 'Error in downloading invoice';
        }
      } else {
        message = err?.response?.data?.message || err?.message || 'Error in downloading invoice';
      }

      toast.error(message);
    }
  });

  const { mutate: handleInvoicePaymentStagesDownload } = useMutation({
    mutationFn: async ({ id, sourceName }) => {
      return await downloadInvoiceForPaymentStages(id, sourceName);
    },
    onSuccess: (data, variables) => {
      const { id, sourceName } = variables;
      if (!data || data.size === 0) {
        toast.error(
          data?.response?.data?.message || data?.message || 'Error in downloading invoice'
        );
        return;
      }
      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `Payment_Stage_${id}_${sourceName}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      onSuccess();
      toast.success('Invoice Downloaded');
    },
    onError: (err) => {
      let message;

      if (err?.response?.data && err?.response?.data instanceof ArrayBuffer) {
        try {
          const decoder = new TextDecoder('utf-8');
          const decoded = decoder.decode(err.response.data);
          if (decoded.includes('Customer details missing, please fill application form')) {
            message = 'Customer details missing, please fill application form';
          } else {
            message = decoded;
          }
        } catch (decodeErr) {
          console.error('Error decoding arraybuffer:', decodeErr);
          message = err?.message || 'Error in downloading invoice';
        }
      } else {
        message = err?.response?.data?.message || err?.message || 'Error in downloading invoice';
      }

      toast.error(message);
    }
  });

  const { mutate: handleApprove } = useMutation({
    mutationFn: (payload) => approveActivity(data?.id, payload),
    onSuccess: () => {
      toast.success('Approved');
      onSuccess();
    }
  });

  const { mutate: handleReject } = useMutation({
    mutationFn: (payload) => approveActivity(data?.id, payload),
    onSuccess: () => {
      toast.success('Rejected');
      onSuccess();
    }
  });

  const handleApproveClick = (leadId) => {
    const payload = {
      name: 'Management Approval',
      lead_id: leadId,
      status: 'Completed'
    };
    handleApprove(payload);
  };

  const handleRejectClick = (leadId) => {
    const payload = {
      name: 'Management Denied',
      lead_id: leadId,
      status: 'Completed'
    };
    handleReject(payload);
  };

  // Mutation for approving loan
  const { mutate: approveLoan, isPending: isApprovingLoan } = useMutation({
    mutationFn: ({ loanId }) =>
      approveCloseDealLoanDetails(loanId, {
        status: 'Approved',
        approved: true
      }),
    onSuccess: () => {
      toast.success('Loan Accepted successfully');
      refetchLoanDetails();
      onSuccess();
      mixpanel.track('Loan Approved from Stage', {
        user_id: userId,
        deal_id: dealId,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to approve loan');
      mixpanel.track('Loan Approval Failed from Stage', {
        user_id: userId,
        deal_id: dealId,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const handleLoanApprovalClick = () => {
    const loanId = loanDetailsData?.data?.id || dealId;
    approveLoan({ loanId });
  };

  // ------------------- RENDER -------------------
  return (
    <div className="flex flex-col w-full flex-shrink-0 border-l border-dashed border-l-gray-400 left-0 gap-5 relative">
      <div className="flex flex-col items-start gap-4  pl-6">
        <div className="flex flex-col gap-0">
          <div className="flex justify-between items-start space-x-4">
            <p className="text-lg font-semibold text-[#2A565E]">
              {data?.name}
              {data?.payment_stage_name ? ' | ' + data?.payment_stage_name : ''}
            </p>
          </div>
          <span className="text-gray-600 mt-[10px]">{''}</span>
        </div>
      </div>

      <div className="w-[96%] flex flex-col gap-2 p-4 rounded-md bg-[#E9F5F6] self-center">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <img src={clocksvg} alt="" />
            <p className="text-gray-700 ">{changeDateToCustomFormat(data?.updated_at)}</p>
          </div>
          <p
            className={`${
              data.status === 'Pending' || data.status === 'sign_pending'
                ? 'bg-[#f15d47]'
                : data.status === 'Completed'
                  ? 'bg-[#c4c3d4]'
                  : ''
            } text-white border p-1 rounded-xl`}>
            {data?.status}
          </p>
        </div>
        <span className="text-gray-500">{data?.description}</span>

        {/* ---------------------------------------
            2) SHOW BUTTON FOR "APPLICATION FORM"
           --------------------------------------- */}
        {data?.name === 'Application Form' && (
          <div className="flex items-center gap-20">
            <div className="mt-2">
              <Button onClick={() => setShowApplicantModal(true)}>Open Application Form</Button>
            </div>
          </div>
        )}

        {/* -----------------------------------------
            Existing conditionals for other forms
           ----------------------------------------- */}
        {data?.name === 'Allotment Letter' && data?.status === 'Completed' ? (
          <div className="flex items-center gap-20">
            <div className="mt-2">
              <Button onClick={() => handleDownloadSigned(selectedDocumentId)} displayType={''}>
                Download Signed Letter
              </Button>
            </div>
          </div>
        ) : data?.name === 'Allotment Letter' && data?.status === 'Pending' ? (
          <div className="flex items-center gap-20">
            <div className="mt-2 flex items-center gap-5">
              <div className="mt-4">
                <Button
                  onClick={() => handleClickOnAllotmentLetter(selectedDocumentId)}
                  displayType={'primary'}>
                  Download
                </Button>
              </div>
              <FormInput
                type={'file-btn'}
                label={'Upload Signed Document'}
                register_key={'allotment_signed_doc'}
                accept={'.pdf'}
                uploadFunctionId={selectedDocumentId}
                uploadFunction={handleUploadAllotmentLetter}
              />
            </div>
          </div>
        ) : (data?.name === 'Aggrement Letter' || data?.name === 'Agreement Letter') &&
          data?.status === 'Completed' ? (
          <div className="flex items-center gap-20">
            <div className="mt-2">
              <Button onClick={() => handleDownloadSigned(selectedDocumentId)} displayType={''}>
                Download Signed Letter
              </Button>
            </div>
          </div>
        ) : (data?.name === 'Aggrement Letter' || data?.name === 'Agreement Letter') &&
          data?.status === 'Pending' ? (
          <div className="flex items-center gap-20">
            <div className="mt-2 flex items-center gap-5">
              <div className="mt-2">
                <Button
                  onClick={() => handleClikcOnAgreementLetter(selectedDocumentId)}
                  displayType={'primary'}>
                  Download
                </Button>
              </div>
              <FormInput
                type={'file-btn'}
                label={'Upload Signed Document'}
                register_key={'agreement_signed_doc'}
                accept={'.pdf'}
                uploadFunctionId={selectedDocumentId}
                uploadFunction={handleUploadAgreementForm}
              />
            </div>
          </div>
        ) : data?.name === 'Demand Note (Invoice)' && data?.status === 'Completed' ? (
          <div className="flex items-center gap-20">
            <div className="mt-2">
              <Button onClick={() => handleInvoiceStagesDownload(dealId)} displayType={''}>
                Download
              </Button>
            </div>
          </div>
        ) : data?.name === 'Invoice Advance' ? (
          <div className="flex items-center gap-20">
            <div className="mt-2">
              <Button onClick={() => handleInvoiceStagesDownload(dealId)} displayType={''}>
                Download
              </Button>
            </div>
          </div>
        ) : data?.name === 'Payment Stage (Invoice)' ? (
          <div className="flex items-center gap-20">
            <div className="mt-2">
              <Button
                onClick={() =>
                  handleInvoicePaymentStagesDownload({
                    id: dealId,
                    sourceName: data?.payment_stage_name
                  })
                }
                displayType={''}>
                Download
              </Button>
            </div>
          </div>
        ) : data?.name === 'Management Approval' && data?.status !== 'Completed' ? (
          <div className="flex items-start gap-4 flex-col">
            <div className="bg-white p-4 rounded-md border border-gray-300 shadow-sm">
              <div className="flex flex-row gap-10 text-sm text-gray-600">
                <p>Initial Price: ₹ {InitialPrice ?? 'N/A'}</p>
                {/* <p>Customer Proposal: ₹{closeDealsById?.customer_proposal ?? 'N/A'}</p> */}
                <p>Final Price: ₹ {allData?.total_price ?? 'N/A'}</p>
                {/* <p>Final Price: ₹ {FinalPrice ?? 'N/A'}</p> */}
              </div>
            </div>
            <div className="flex gap-3">
              <div className="mt-2">
                <Button
                  disabled={userVertical !== 'Management'}
                  onClick={() => handleApproveClick(data?.lead_id)}
                  displayType={''}>
                  Approve
                </Button>
              </div>
              <div className="mt-2">
                <Button
                  disabled={userVertical !== 'Management'}
                  onClick={() => handleRejectClick(data?.lead_id)}
                  customStyle={{
                    backgroundColor: '#f15d47',
                    color: 'white',
                    borderColor: '#f15d47'
                  }}>
                  Reject
                </Button>
              </div>
            </div>
          </div>
        ) : data?.name === 'Loan Approval' &&
          data?.status !== 'Completed' &&
          loanDetailsData?.data &&
          loanDetailsData?.data?.approved !== true ? (
          <div className="flex items-center gap-20">
            <div className="mt-2">
              <Button onClick={handleLoanApprovalClick} disabled={isApprovingLoan} displayType={''}>
                {isApprovingLoan ? 'Accepting...' : 'Loan Approved'}
              </Button>
            </div>
          </div>
        ) : null}
      </div>

      <img
        src={`/icons/${special ? 'document' : 'organisation'}.svg`}
        alt="document_icon"
        className="absolute left-[-10px] top-0 bg-white"
      />

      {/* -----------------------------------
          3) RENDER THE MODAL CONDITIONALLY
         ----------------------------------- */}
      {showApplicantModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name="Application Form"
          onClose={() => setShowApplicantModal(false)}
          width={50}>
          <ApplicantModal
            dealId={dealId}
            onClose={() => {
              setShowApplicantModal(false);
              window.location.reload();
            }}
          />
        </Modal>
      )}
    </div>
  );
};

export default DealCard;
